// ----------------------
// <auto-generated>
// Generated using the script apiGenerator.js
// </auto-generated>
// -----------------------
import { configuration } from 'config/constants';
import {
    HealthClient,
    PopsClient,
    RequestUsersClient,
    RequestsClient,
    ServicesClient,
} from './RequestAccessProxyApiClient';
import { http } from 'services/ApiService/Http';

const { baseApiUrls: { requestAccessProxy: baseApiUrl } } = configuration;

export const HealthApi = new HealthClient(baseApiUrl, http);
export const PopsApi = new PopsClient(baseApiUrl, http);
export const RequestUsersApi = new RequestUsersClient(baseApiUrl, http);
export const RequestsApi = new RequestsClient(baseApiUrl, http);
export const ServicesApi = new ServicesClient(baseApiUrl, http);
